import { Box } from "@mui/material";

import NotificationCardWrapper from "../NotificationCardWrapper";
import Info from "../../../../media/svg/Info";

const ReportAccountEleminated = ({ data }) => {
  return (
    <NotificationCardWrapper
      firstChild={<Info />}
      seccondChild={<Box style={{ width: "100%" }}>{data?.description}</Box>}
      styling={{ marginTop: "10px" }}
    />
  );
};

export default ReportAccountEleminated;
